import { render } from "./Tareas.vue?vue&type=template&id=a14890a4"
const script = {}

import exportComponent from "/home/ubuntu/NewMov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__